export default __webpack_public_path__ + "static/media/useconexlogo.aa6b43bf.png";